import { jsx } from "react/jsx-runtime";
import B2BLayout from "../B2BLayout/B2BLayout.esm.js";
import { HEADER_CTAS, FOOTER_COLUMNS, LAYOUT_MENU_ITEMS } from "./constants/layout.esm.js";
import logoSvg from "./constants/logo.svg.esm.js";
const ConstructionLayout = ({
  children,
  submenu,
  header,
  router,
  environment
}) => {
  const logo = {
    src: logoSvg,
    alt: "Zillow New Construction",
    width: 154,
    height: 27,
    link: "https://www.zillow.com/new-construction-advertising/"
  };
  return /* @__PURE__ */ jsx(B2BLayout, { router, env: environment, signInLink: "https://builders.zillowgroup.com/login/", signInRedirectParam: "url", logo, menu: LAYOUT_MENU_ITEMS, submenu, transparent: header == null ? void 0 : header.transparent, disabled: header == null ? void 0 : header.disabled, footerColumns: FOOTER_COLUMNS, primaryCTALink: HEADER_CTAS.primary.url, primaryCTALabel: HEADER_CTAS.primary.label, secondaryCTALink: HEADER_CTAS.secondary.url, secondaryCTALabel: HEADER_CTAS.secondary.label, sticky: true, children });
};
export {
  ConstructionLayout as default
};
